import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { ModelService } from '../services/model.service';

@Component({
  selector: 'app-legaltext',
  templateUrl: './legaltext.component.html',
  styleUrls: ['./legaltext.component.scss']
})
/*Componente creado, en register, cuando el usuario indica que quiere ser un nuevo usuario(no está registrado), aparece este componente para detallar las 
condiciones de politica de RIVISA 
*/
export class LegaltextComponent implements OnInit {

  continuar = 'blockbotton'; //clase en SaaS que bloquea el boton de continuar
  checkTerms = true; //variable para indicar que el checkbox está deshabilitado

  constructor(public modelService : ModelService) { }

  ngOnInit(): void {

  }

  //funcion del checkbox acepte, puedas tener el boton habilitado sass - blockbotton
  clickCheck( ){
    this.checkTerms = !this.checkTerms; 
      return this.checkTerms ? this.continuar = 'blockbotton' : this.continuar = ' ';
  }
}
